import React from 'react'
import { withRouter } from 'react-router'
import { BASE_API } from '../../../api'
import gwasviz_single_trait_conf from './conf/gwasviz_single_trait_conf'
import './css/locuszoom.css'

class SingleTraitLocuszoom extends React.Component {
    state = {
        config: {
            // locuszoom 图默认展示区间
            species: gwasviz_single_trait_conf.species,
            query_trait: gwasviz_single_trait_conf.query_trait,
            query_chr: gwasviz_single_trait_conf.query_chr,
            query_loc_start: gwasviz_single_trait_conf.query_loc_start,
            query_loc_end: gwasviz_single_trait_conf.query_loc_end,
        },
        plot: '',
    }

    // componentWillReceiveProps 生命周期函数已不建议使用，所以改用此函数
    static getDerivedStateFromProps(props, state) {
        if ((JSON.stringify(props.locuszoom_config) !== JSON.stringify(state.config)) && state.plot !== '') {
            const { species, query_trait, query_chr, query_loc_start, query_loc_end } = props.locuszoom_config
            
            const plot = state.plot
            
            if (plot) {
                plot.applyState({ species: species, trait: query_trait, chr: query_chr, start: query_loc_start, end: query_loc_end })
            }

            return {
                species: species,
                query_trait: query_trait,
                query_chr: query_chr,
                query_loc_start: query_loc_start,
                query_loc_end: query_loc_end
            }
        }

        return {}
    }

    componentDidMount() {
        const { species, query_trait, query_chr, query_loc_start, query_loc_end } = this.props.locuszoom_config
        const LocusZoom = window.LocusZoom
        
        /******************** populate GWAS LocusZoom ********************/
        
        // 配置数据源
        let data_sources = new LocusZoom.DataSources()
          .add("assoc", ["CottonAssociationLZ", {url: BASE_API + "/gwasviz/retrive_assoc"}])
          .add("ld", ["CottonLDServer", {url: BASE_API + "/gwasviz/retrive_ld"}])
          .add("gene", ["CottonGeneLZ", {url: BASE_API + "/gwasviz/retrive_gene"}])
        
        // 默认展示species, trait 及区间
        let initialState = { species: species, trait: query_trait, chr: query_chr, start: query_loc_start, end: query_loc_end }
        let layout = LocusZoom.Layouts.get("plot", "cotton_standard_association", {state: initialState})
        let plot = LocusZoom.populate("#lz-plot", data_sources, layout)
        
        this.setState({
            plot: plot
        })
    }

    render() {
        return (
            <div id="lz-plot"></div>
        )
    }
}

export default withRouter(SingleTraitLocuszoom)
